<template>
    <div>
        <div class=" mb-3">
            <div class="d-flex justify-content-between">
                <div class=" mb-3">
                    <h3 class="">{{ agency }}</h3>
                </div>

                <div class="d-flex">
                    <div class=" mb-2 mr-2" v-if="this.certificates.length > 0">Pending Authentication ({{ this.pendingAuthentication }})</div>
                    <div v-if="this.certificates.length > 0">Unauthenticated Certificates ({{ this.unauthenticatedCertificates }})</div>
                </div>
            </div>
            <div class="mb-2">Remaining quota for the day: {{ remaining_quota }}</div>
            <button :disabled="!certificate_ids.length > 0" @click="sendCertificates" class="btn btn-label btn-primary btn-sm">
                <i class="bx bx-mail-send label-icon"></i>
                Send Batch
            </button>
        </div>
        <div>
            <webix-ui :config="ui" v-model="certificates"></webix-ui>
        </div>
    </div>
</template>

<script>
import { vettingComputed, vettingMethods, suppliersComputed, suppliersMethods } from "../../../state/helpers";
import Swal from "sweetalert2";

export default {
    props: {
        agency: {},
        certificates: {},
        remaining_quota: {},
    },
    data: () => ({
        certificate_ids: [],
        vettingCount: 0,
        pendingAuthentication: 0,
        unauthenticatedCertificates: 0,
    }),
    computed: {
        ...vettingComputed,
        ...suppliersComputed,
        pagerName() {
            return this.agency + "Pager";
        },
        ui() {
            //eslint-disable-next-line
            console.log("the name in the computed", this.agency);
            // return [];
            let el = this;

            //eslint-disable-next-line
            console.log("the agency name", el.agency);

            let ui = {
                id: el.agency,
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "suppliersTableHoverRow",
                minHeight: 50,
                minColumnWidth: 150,
                rowHeight: 30,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                // select: true,
                editable: true,
                // pager: {
                //     id: el.pagerName,
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "vettingTablePaging",
                //     css: { width: "100% !important" },
                //     size: 15,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "value",
                        header: { text: "Add", css: { "text-align": "center" } },
                        tooltip: false,
                        maxWidth: 65,
                        css: { "text-align": "center" },
                        template: function(obj) {
                            if (obj.value == 1) {
                                return `<div class="on_collect"><i class="mdi mdi-check-box-outline bx-sm
                                     non-active_switch"></i> </div>`;
                            }
                            if (obj.value == 2) {
                                //                                 return `<div class="on_collect"><i class="bx bx-square-rounded
                                //  bx-sm active_switch"></i> </div>`;
                                return `<div class="on_collect"><i class="mdi mdi-checkbox-blank-outline bx-sm active_switch"></i> </div>`;
                            }
                            if (obj.value == 3) {
                                return "";
                            }
                        },
                    },
                    {
                        id: "client_name",
                        header: { text: "Client Name", css: { "text-align": "center" } },
                        tooltip: false,
                        width: 300,
                    },
                    {
                        id: "company_name",
                        header: { text: "Supplier", css: { "text-align": "center" } },
                        tooltip: false,
                        width: 300,
                    },
                    {
                        id: "vat_no",
                        header: { text: "Vat No", css: { "text-align": "center" } },
                        tooltip: false,
                    },
                    {
                        id: "company_reg",
                        header: { text: "Company Reg No", css: { "text-align": "center" } },
                        tooltip: false,
                    },
                    {
                        id: "authentication_status",
                        header: { text: "Status", css: { "text-align": "center" } },
                        css: { "text-align": "center" },
                        tooltip: false,
                        width: 200,
                        sort: "string",
                        //eslint-disable-next-line
                        template: function(obj) {
                            if (obj.authentication_status == "Pending Authentication") {
                                // return "<b-button variant='primary' class='open_modal'>click my</b-button>";
                                return `<div class='open_modal'>${obj.authentication_status}</div>`;
                            }
                            if (obj.authentication_status == null) {
                                // return "<b-button variant='primary' class='open_modal'>click my</b-button>";
                                return `Not Authenticated`;
                            }
                            return obj.authentication_status;
                        },
                        //eslint-disable-next-line
                        cssFormat: function(value, config) {
                            //eslint-disable-next-line
                            // console.log("what uis value returning", value);
                            if (value == `<div class='open_modal'>Pending Authentication</div>`) {
                                // if (value.authentication_status)
                                // return "bg-danger pointer-changed";
                                return "pointer-changed";
                            }
                        },
                    },
                    {
                        id: "authentication_request_date",
                        header: { text: "Auth Request Date", css: { "text-align": "center" } },
                        css: { "text-align": "center" },
                        tooltip: false,
                        width: 200,
                        sort: "string",
                    },
                ],
                ready() {
                    // el.resize_event = window.webix.event(window, "resize", function() {
                    //     el.$nextTick(() => {
                    //         window.webix.$$(el.ui.id).refresh();
                    //     });
                    // });
                },
                on: {},
                onChange: {},
                onClick: {
                    //eslint-disable-next-line
                    on_collect: function(event, id) {
                        let el = this.$scope.$parent;

                        let table = window.webix.$$(el.agency);

                        //eslint-disable-next-line
                        console.log("the tablkes name", table);

                        let item = this.getItem(id);
                        //eslint-disable-next-line
                        console.log("getItem", item.value);

                        //eslint-disable-next-line

                        // el.handleSwal(item);
                        // el.upd(item);

                        if (item.value == 1) {
                            const index = el.certificate_ids.indexOf(item.id);
                            if (index >= 0) {
                                // If 5 is already in the array, remove it
                                el.certificate_ids.splice(index, 1);
                            }
                            //eslint-disable-next-line
                            console.log("was it removed", el.certificate_ids, "the index value", index);
                            //eslint-disable-next-line
                            console.log("the id", item);
                            //eslint-disable-next-line

                            item.value = 2;
                            // el.vettingTableData[1].value = 2;

                            table.updateItem(item.id, item);
                            el.vettingCount += 1;

                            //eslint-disable-next-line
                            console.log("actiual value2", item.value, event);

                            return;
                            // table.refresh();
                        }

                        if (el.vettingCount > 0) {
                            if (item.value == 2) {
                                const index = el.certificate_ids.indexOf(item.id);
                                if (index === -1) {
                                    // If 5 is not in the array, push it
                                    el.certificate_ids.push(item.id);
                                }

                                //eslint-disable-next-line
                                else console.log("this was run");
                                item.value = 1;
                                // el.vettingTableData[1].value = 2;
                                //eslint-disable-next-line
                                console.log("2: actiual value2", item.value);

                                table.updateItem(item.id, item);
                                el.vettingCount -= 1;

                                // table.refresh();
                                return;
                            }
                        } else {
                            el.handleSwal();
                        }
                    },
                    //eslint-disable-next-line
                    open_modal(event, id) {
                        //eslint-disable-next-line
                        // let el = this.$scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent;
                        // let el = this.$scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent;
                        let el = this.$scope.$parent;
                        //eslint-disable-next-line
                        let item = this.getItem(id);
                        //eslint-disable-next-line
                        // el.setSelectedCertificate(item);
                        el.setTeamMembersForCertificates();
                        //eslint-disable-next-line
                        console.log("the cell was clicked", item);
                        // el.vett;
                        el.setSelectedCertificateForAuthentication(item);
                        el.$emit("handleModal", "certificatePendingAuthenticationModal");
                    },
                },
            };

            return ui;
        },
    },
    methods: {
        ...vettingMethods,
        ...suppliersMethods,
        handleSwal() {
            Swal.fire({
                title: `Maximum allocation reached`,
                text: `Only 10 certificates may be sent for authentication per day`,
                icon: "warning",
                // showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Ok",
            }).then((result) => {
                if (result.value) {
                    //eslint-disable-next-line
                }
            });
        },

        sendCertificates() {
            Swal.fire({
                title: `Send for Authentication?`,
                text: `Are you sure`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    //eslint-disable-next-line
                    this.sendCertificatesForVetting({ certificate_ids: this.certificate_ids }).then(() => {
                        //
                        Swal.fire({ title: ``, text: "Certificate sent for authentication", icon: "success" });
                        this.setCertificatesForVetting();
                    });
                }
            });
        },
    },
    mounted() {
        this.vettingCount = this.remaining_quota;

        for (let i = 0; i < this.certificates.length; i++) {
            //
            if (this.certificates[i].authentication_status == null) {
                //eslint-disable-next-line
                console.log("gooi");
                this.unauthenticatedCertificates += 1;
            }

            if (this.certificates[i].authentication_status == "Pending Authentication") {
                this.pendingAuthentication += 1;
            }
        }
    },
};
</script>

<style lang="scss">
.pointer-changed {
    cursor: pointer;
    &:hover {
        background-color: #266aa8;
        color: white;
    }
}
.active_switch {
    // color: darken(#28a745, 10%);
    cursor: pointer;
    font-weight: 100;
}
.non-active_switch {
    cursor: pointer;
}
</style>
